module.exports = __webpack_public_path__ + "img/bio_certif.32bfb481.png";